<div :class="[{ 'collapsed': collapsed }]">
  <sidebar-menu :width="sidebardwith" :menu="menu" :collapsed="collapsed" :show-one-child="true"
    @update:collapsed="onToggleCollapse" />
  <div v-if="!collapsed && isOnMobile" class="sidebar-overlay" @click="collapsed = true"></div>
</div>

<!-- <div :class="[{'collapsed' : collapsed}, {'onmobile' : isOnMobile}]">
    <sidebar-menu :width="sidebardwith" :menu="menu" :collapsed="collapsed" :theme="selectedTheme" :show-one-child="true"
      @toggle-collapse="onToggleCollapse" />
    <div v-if="isOnMobile && !collapsed" class="sidebar-overlay" @click="collapsed = true">
    </div>
  </div> -->